{
    "name": "arcus",
    "version": "2026.10.8-1",
    "description": "",
    "private": true,
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:local": "ng serve --configuration=local",
        "stage": "ng serve --configuration=staging",
        "stage:local": "ng serve --configuration=staging-local",
        "prod": "ng serve --configuration=production",
        "prod:local": "ng serve --configuration=production-local",
        "hmr": "ng serve --configuration hmr",
        "build": "ng build",
        "production": "ng build --configuration production",
        "staging": "ng build --configuration staging",
        "test": "ng test",
        "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet --fix",
        "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html}\" --write && npx stylelint \"src/**/*.{scss,css}\" --fix",
        "e2e": "ng e2e",
        "prepare": "husky",
        "fix-styles": "npx stylelint \"src/**/*.{css,scss}\" --fix",
        "fix-code": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html}\" --write",
        "serve:ssr:Arcus": "node dist/server/server.mjs",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org arcus-load-management --project arcus-frontend ./dist && sentry-cli sourcemaps upload --org arcus-load-management --project arcus-frontend ./dist"
    },
    "keywords": [],
    "author": "",
    "license": "ISC",
    "dependencies": {
        "@angular-devkit/schematics": "^20.3.21",
        "@angular/animations": "^20.3.18",
        "@angular/cdk": "^20.2.14",
        "@angular/cli": "^20.3.21",
        "@angular/common": "^20.3.18",
        "@angular/compiler": "^20.3.18",
        "@angular/compiler-cli": "^20.3.18",
        "@angular/core": "^20.3.18",
        "@angular/forms": "^20.3.18",
        "@angular/language-service": "^20.3.18",
        "@angular/localize": "^20.3.18",
        "@angular/material": "^20.2.14",
        "@angular/platform-browser": "^20.3.18",
        "@angular/platform-browser-dynamic": "^20.3.18",
        "@angular/platform-server": "^20.3.18",
        "@angular/router": "^20.3.18",
        "@angular/service-worker": "^20.3.18",
        "@angular/ssr": "^20.3.21",
        "@angular/upgrade": "^20.3.18",
        "@auth0/auth0-angular": "^2.7.0",
        "@fortawesome/angular-fontawesome": "^3.0.0",
        "@fortawesome/fontawesome-free": "^6.7.2",
        "@fortawesome/fontawesome-svg-core": "^6.7.2",
        "@fortawesome/free-brands-svg-icons": "^6.7.2",
        "@fortawesome/free-regular-svg-icons": "^6.7.2",
        "@fortawesome/free-solid-svg-icons": "^6.7.2",
        "@microsoft/signalr": "^9.0.6",
        "@popperjs/core": "^2.11.8",
        "@progress/kendo-angular-buttons": "^20.1.2",
        "@progress/kendo-angular-charts": "^20.1.2",
        "@progress/kendo-angular-common": "^20.1.2",
        "@progress/kendo-angular-conversational-ui": "^20.1.2",
        "@progress/kendo-angular-dateinputs": "^20.1.2",
        "@progress/kendo-angular-dialog": "^20.1.2",
        "@progress/kendo-angular-dropdowns": "^20.1.2",
        "@progress/kendo-angular-editor": "^20.1.2",
        "@progress/kendo-angular-excel-export": "^20.1.2",
        "@progress/kendo-angular-grid": "^20.1.2",
        "@progress/kendo-angular-icons": "^20.1.2",
        "@progress/kendo-angular-inputs": "^20.1.2",
        "@progress/kendo-angular-intl": "^20.1.2",
        "@progress/kendo-angular-l10n": "^20.1.2",
        "@progress/kendo-angular-label": "^20.1.2",
        "@progress/kendo-angular-layout": "^20.1.2",
        "@progress/kendo-angular-pager": "^20.1.2",
        "@progress/kendo-angular-pdf-export": "^20.1.2",
        "@progress/kendo-angular-popup": "^20.1.2",
        "@progress/kendo-angular-progressbar": "^20.1.2",
        "@progress/kendo-angular-sortable": "^20.1.2",
        "@progress/kendo-angular-toolbar": "^20.1.2",
        "@progress/kendo-angular-tooltip": "^20.1.2",
        "@progress/kendo-angular-treeview": "^20.1.2",
        "@progress/kendo-angular-upload": "^20.1.2",
        "@progress/kendo-data-query": "^1.7.4",
        "@progress/kendo-drawing": "^1.24.1",
        "@progress/kendo-licensing": "^1.10.1",
        "@progress/kendo-svg-icons": "^4.8.0",
        "@progress/kendo-theme-material": "^10.6.0",
        "@sentry/angular": "^10.45.0",
        "@sentry/cli": "^2.58.5",
        "@telerik/kendo-intl": "^2.3.1",
        "calendar-link": "^2.11.0",
        "canvas-confetti": "^1.9.4",
        "core-js": "^3.49.0",
        "dayjs": "^1.11.20",
        "express": "^5.2.1",
        "hammerjs": "^2.0.8",
        "is-mobile": "^5.0.0",
        "jquery": "^3.7.1",
        "kendo-custom": "file:./src/styles/kendo-custom",
        "leaflet": "^1.9.4",
        "lodash-es": "^4.17.23",
        "ngx-toastr": "^19.1.0",
        "powerbi-client": "^2.23.10",
        "prettier-plugin-organize-imports": "^4.3.0",
        "reset-css": "^5.0.2",
        "respond.js": "^1.4.2",
        "rxjs": "^7.8.2",
        "rxjs-compat": "^6.6.7",
        "sass": "^1.98.0",
        "signalr": "^2.4.3",
        "stylelint": "^16.26.1",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^20.3.21",
        "@angular-eslint/builder": "19.3.0",
        "@angular-eslint/eslint-plugin": "19.3.0",
        "@angular-eslint/eslint-plugin-template": "19.3.0",
        "@angular-eslint/schematics": "19.3.0",
        "@angular-eslint/template-parser": "19.3.0",
        "@angularclass/hmr": "^3.0.0",
        "@types/express": "^5.0.6",
        "@types/jasmine": "^5.1.15",
        "@types/jasminewd2": "^2.0.13",
        "@types/jquery": "^3.5.34",
        "@types/leaflet": "^1.9.21",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "^20.17.58",
        "@types/signalr": "^2.4.3",
        "@typescript-eslint/eslint-plugin": "^8.57.1",
        "@typescript-eslint/parser": "^8.57.1",
        "eslint": "^9.39.4",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-prettier": "^5.5.5",
        "husky": "^9.1.7",
        "jasmine": "^5.13.0",
        "jasmine-core": "^5.13.0",
        "jasmine-spec-reporter": "7.0.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "^3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-coverage-istanbul-reporter": "^3.0.3",
        "karma-jasmine": "^5.1.0",
        "karma-jasmine-html-reporter": "^2.2.0",
        "karma-junit-reporter": "^2.0.1",
        "lint-staged": "^16.4.0",
        "prettier": "^3.8.1",
        "pretty-quick": "^4.2.2",
        "stylelint-config-prettier-scss": "^1.0.0",
        "stylelint-config-standard": "^39.0.1",
        "stylelint-config-standard-scss": "^16.0.0",
        "stylelint-prettier": "^5.0.3",
        "typescript": "^5.9.3"
    },
    "optionalDependencies": {
        "ts-node": "^10.9.2"
    },
    "lint-staged": {
        "src/**/*.{js,jsx,ts,tsx}": [
            "eslint . --fix",
            "git add"
        ],
        "src/**/*.{scss,css}": [
            "stylelint --fix",
            "git add"
        ]
    },
    "husky": {
        "hooks": {
            "pre-commit": "lint-staged && pretty-quick --staged"
        }
    }
}
